const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const CDN_PROXY_URL = `${BACKEND_URL}/api/projects`;

const AVATAR_COLORS = [
  '#e17076', '#7bc862', '#65aadd', '#a695e7',
  '#ee7aae', '#5fcaef', '#f4b459', '#52b2de',
];

const getInitials = (title) => {
  if (!title) return '??';
  const words = title.trim().split(/\s+/);
  if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase();
  return title.substring(0, 2).toUpperCase();
};

const getLastActivity = (year) => {
  const diff = new Date().getFullYear() - parseInt(year || 2025);
  if (diff === 0) return '1 мин';
  if (diff === 1) return '30 мин';
  if (diff === 2) return '2 часа';
  return '1 день';
};

const buildMessages = (project) => {
  const msgs = [];
  let id = 1;

  // Launch year
  msgs.push({ id: id++, type: 'system', text: `Проект · ${project.year}` });

  // Short description
  if (project.short_description_ru) {
    msgs.push({ id: id++, type: 'incoming', text: project.short_description_ru, time: '10:00' });
  }

  // Developer question
  msgs.push({ id: id++, type: 'outgoing', text: 'Расскажи подробнее', time: '10:01' });

  // Full description from JSON
  if (project.description_ru) {
    msgs.push({ id: id++, type: 'description', text: project.description_ru, time: '10:02' });
  }

  // Video if available
  const videoUrl = project.video_desktop || project.video_mobile;
  if (videoUrl) {
    msgs.push({ id: id++, type: 'video', url: videoUrl, time: '10:03' });
  }

  return msgs;
};

export const loadProjects = async () => {
  const resp = await fetch(CDN_PROXY_URL);
  if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
  const data = await resp.json();
  const bots = (data.projects || []).filter(p => p.type === 'tb' && !p.hidden).reverse();
  return bots.map((project, i) => ({
    id: project.id,
    name: project.title_ru,
    username: project.link
      ? `@${project.link.replace('https://t.me/', '')}`
      : `@${project.id}`,
    color: AVATAR_COLORS[i % AVATAR_COLORS.length],
    initials: getInitials(project.title_ru),
    tagline: project.short_description_ru,
    lastActivity: getLastActivity(project.year),
    isOnline: !!project.link,
    memberCount: project.link ? 'Демо доступно' : 'Приватный бот',
    link: project.link || null,
    year: project.year,
    messages: buildMessages(project),
    // SEO fields for dynamic meta tags
    short_description_ru: project.short_description_ru,
    seo_description_ru: project.seo_description_ru,
    seo_title_ru: project.seo_title_ru,
    keywords_ru: project.keywords_ru,
  }));
};
